var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{attrs:{"id":"nav"}},[_c('router-link',{attrs:{"to":"/"}},[_vm._v("Home")]),_vm._v("\n        |\n        "),_c('router-link',{attrs:{"to":"/bingo"}},[_vm._v("Bingo")])],1),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }